import Form from "../../form/Form";
import UsePoints from "JS/classes/UsePoints";
import Coupon from "./Coupon";
import { notice } from "../../utils/notice";

export default class Checkout {

    formElement;
    dataBuffer = {};
    listeners = new Map();

    listCitiesContainer;
    listCities;
    searchLabelCity;

    inputCityContainer;
    inputState;
    inputCountry;
    inputCity;
    inputAddresses;
    inputAddress_1;
    inputAddress_2;
    addressFields = ['Country', 'State', 'Address_1', 'Address_2'];

    cityData;

    /**
     * @type {Coupon}
     */
    coupon;

    /**
     * @type {HTMLElement}
     */
    loader;

    /**
     * @type {HTMLElement}
     */
    submitButton;

    timeouts = {};

    constructor() {
        this.formElement = document.querySelector('#checkout-form');

        if (!this.formElement) {
            return;
        }

        this.initCities();
        this.initUpdateCheckoutEvent();

        this.loader = document.querySelector('.checkout-loader');
        this.submitButton = this.formElement.querySelector('.checkout-template__submit');

        this.UsePoints = new UsePoints('checkout', this);
        this.coupon = new Coupon(this);

        this.form = new Form(this.formElement);

        this.dataBuffer = {...this.form.collectValues()};
        
        this.form.on('change', (data) => {
            this.compareData(data);
        });
        
        this.form.on('submit', (data) => {
            this.checkout(data);
        });

        this.onChange('shipping_method[0]', (val) => {
            this.updateOrderReview(this.dataBuffer);
        });

    }


    initCities() {
        this.inputAddresses = this.formElement.querySelectorAll('input[name="customer-addresses"]');

        if (this.inputAddresses) {
            this.inputAddresses.forEach(elm => elm.addEventListener('click', this._selectCustomerAddress));
        }

        this.inputCity = this.formElement.querySelector('input[name="billing_city"]');

        this.addressFields.forEach(field => {
            this[`input${field}`] = this.formElement.querySelector(`input[name="billing_${field.toLowerCase()}"]`);
            this[`input${field}`].addEventListener('input', (e) => {
                if (this[`input${field}`].value != this[`input${field}`].getAttribute('data-selected')) {
                    this.resetInputAddresses();
                }
            })
        })

        this.inputCity.readOnly = true;
        this.inputCity.setAttribute('autocomplete', 'off');

        this.listCitiesContainer = document.createElement('div');
        this.listCitiesContainer.classList.add('cities-list-wrapper');
        
        this.inputCityContainer = this.inputCity.parentNode.parentNode;
        this.inputCityContainer.appendChild(this.listCitiesContainer);
        this.inputCityContainer.classList.add('input-wrap--billing-city');

        this.inputCityContainer.addEventListener('click', (e) => {
            e.preventDefault();
            e.stopPropagation();
            this.showCitiesList();
        });

        document.addEventListener('click', (e) => {
            if (!e.target.closest('input-wrap--billing-city')) {
                this.hideCitiesList();
            }
        });

        this.listCitiesContainer.innerHTML += `
        <div class="input-wrap">
            <label class="form-input-type-text form-input form-input--search-city" data-input-type="text">
                <input name="search_city" placeholder="поиск города" type="text" value="" class="search-city">
            </label>
        </div>`;

        this.onChange('search_city', (val) => {
            this.requestCities(val);
        });

        this.searchLabelCity = this.listCitiesContainer.querySelector('.form-input--search-city');

        this.listCities = document.createElement('ul');
        this.listCities.classList.add('cities-list');
        this.listCitiesContainer.appendChild(this.listCities);
        this.listCities.addEventListener('click', this.clickCitiesList);

        var inputEvent = new Event('input', {
            bubbles: true,
        });

        // Присваиваем импуту уже выбранный город
        document.addEventListener('DOMContentLoaded', () => {
            if (edostavka_checkout_params.customer_location.city) {
                this.inputCity.value = edostavka_checkout_params.customer_location.city;
                this.inputCity.setAttribute('data-selected', this.inputCity.value);
                this.inputCity.dispatchEvent(inputEvent);

                this.cityData = this.collectCityData();
            } 
        });
    }


    resetInputAddresses() {
        this.inputAddresses.forEach(elm => {
            if (elm.checked) {
                elm.checked = false;
            }
        });
    }


    _selectCustomerAddress = async (e) => {
        const location = JSON.parse(e.target.value);
        if (location) {
            const result = await this.setCustomerLocation(location);
            if (result) {
                var inputEvent = new Event('input', {
                    bubbles: true,
                });

                this.addressFields.forEach(field => {
                    this[`input${field}`].value = e.target.getAttribute(field);
                    this[`input${field}`].setAttribute('data-selected', e.target.getAttribute(field));
                    this[`input${field}`].dispatchEvent(inputEvent);
                })
            }
        }
    }


    collectCityData() {
        let location = {};
        const c_loc = edostavka_checkout_params.customer_location;
        if (c_loc) {
            c_loc.country = c_loc.country ?? 'Россия';
            location = {
                '_resultId':    c_loc.city_code,
                'id':           c_loc.city,
                'text':         c_loc.city,
                'title':        `${c_loc.country}, ${c_loc.region}, ${c_loc.city}`,
                'code':         c_loc.city_code,
                'region':       c_loc.region,
                'region_code':  c_loc.region_code,
                'sub_region':   c_loc.sub_region,
                'country':      c_loc.country,
                'country_code': c_loc.country_code,
                'longitude':    c_loc.longitude,
                'latitude':     c_loc.latitude,
                'selected':     true,
            };
        }
        return location;
    }


    initUpdateCheckoutEvent() {
        jQuery(document).on('ajaxComplete', (e, xhr, setting) => {
            const url = setting.url;
            if (url.includes('edostavka_set_delivery_point')) {
                this.updateOrderReview(this.dataBuffer);
            }
        })
    }


    checkout(data) {
        if (this.loader) {
            this.loader.classList.add('active');
        }

        if (this.submitButton) {
            this.submitButton.classList.add('processing');
        }

        const formData = this.prepareData(data, false);

        fetch(`${backendData.siteUrl}?wc-ajax=checkout`, {
            method: 'POST',
            body: formData,
        })
            .then(resp => resp.json())
            .then(data => {
                //console.log(data);

                if (data.redirect) {
                    window.location.href = data.redirect;
                }

                if (data.messages) {
                    notice(data.messages, data.result === 'success' ? 'default' : 'error');
                }
            })
            .finally(() => {
                if (this.loader) {
                    this.loader.classList.remove('active');
                }

                if (this.submitButton) {
                    this.submitButton.classList.remove('processing');
                }
            });
    }

    updateOrderReview(data) {
        if (this.loader) {
            this.loader.classList.add('active');
        }

        const formData = this.prepareData(data);

        fetch(`${backendData.siteUrl}?wc-ajax=update_order_review`, {
            method: 'POST',
            body: formData,
        })
            .then(resp => resp.json())
            .then(data => {
                //console.log(data);

                if (data.fragments) {
                    this.replaceFragments(data.fragments);
                }

                if (data.messages) {
                    notice(data.messages, data.result === 'success' ? 'default' : 'error');
                }
            })
            .finally(() => {
                if (this.loader) {
                    this.loader.classList.remove('active');
                }
            });
    }

    replaceFragments(fragments) {
        const fragmentsSelectors = {
            '.woocommerce-checkout-review-order-table': '#order_review',
            '.woocommerce-checkout-payment': '#payment',
            '#shipping': '#shipping',
        };

        Object.keys(fragments).forEach(key => {
            if (!fragmentsSelectors[key]) {
                return;
            }

            const wrap = document.createElement('div');

            wrap.innerHTML = fragments[key];

            const oldElement = this.formElement.querySelector(fragmentsSelectors[key]);
            const newElement = wrap.querySelector(fragmentsSelectors[key]);

            if (!newElement || !oldElement) {
                return;
            }

            oldElement.replaceWith(newElement);
        });
        this.updateFields();
        this.submitButton = this.formElement.querySelector('.checkout-template__submit');
    }

    prepareData(data, replace = true) {
        const output = new FormData();

        Object.keys(data).forEach(key => {
            if (replace) {
                output.append(key.replace('billing_', ''), data[key]);
            } else {
                output.append(key, data[key]);
            }
        });

        output.append('security', backendData.security_nonce);
        output.append('post_data', new URLSearchParams(data));
        output.append('billing_cdek_addr_data', JSON.stringify(this.cityData));

        return output;
    }

    compareData(data) {
        const keys = [];
        Object.keys(data).forEach(key => {
            if (!this.dataBuffer[key]) {
                if (data[key]) {
                    keys.push(key);
                }
                return;
            }
            if (data[key] !== this.dataBuffer[key]) {
                keys.push(key);
            }
        });

        this.dataBuffer = {...data};
        this.triggerChange(keys, data);
    }

    triggerChange(keys = [], data) {
        
        keys.forEach(key => {

            const evtName = `change_${key}`;

            if (this.timeouts[evtName]) {
                clearTimeout(this.timeouts[evtName]);
            }

            if (this.listeners.has(evtName)) {
                this.timeouts[evtName] = setTimeout(() => {
                    const callbacks = this.listeners.get(evtName);
                    Object.values(callbacks).forEach(callback => {
                        callback(data[key]);
                    });
                }, 300);
            }
        });
    }

    onChange(fieldName = '', handler) {
        const evtName = `change_${fieldName}`;
        this.listeners.has(evtName) || this.listeners.set(evtName, []);
        this.listeners.get(evtName).push(handler);
    }

    updateFields() {
        const inactiveFields = [];

        this.form.fields.forEach(field => {
            if (document.body.contains(field.inputElement)) {
                return;
            }
            inactiveFields.push(field);
        });

        inactiveFields.forEach(f => {
            const ind = this.form.fields.indexOf(f);
            this.form.fields.splice(ind, 1);
        });

        this.form.initFields();
        this.dataBuffer = {...this.form.collectValues()};
    }


    requestCities(city) {
        this.searchLabelCity.classList.add('proccessing');

        this.listCities.innerHTML = '';
        this.listCitiesContainer.classList.remove('scroll');

        const formData = new FormData();

        formData.append('action', 'edostavka_get_location_cities');
        formData.append('city', city);
        formData.append('country_codes', this.inputCountry.value);
        formData.append('size', 10);

        fetch(backendData.ajaxUrl, {
            method: 'POST',
            body: formData,
        })
            .then(resp => resp.json())
            .then(response => {
                const {
                    data,
                    success,
                } = response;
                
                if (data.length > 0) {
                    data.forEach((item) => {
                        if (item.code) {
                            const new_elm = document.createElement('li');
                            new_elm.classList.add('cities-list__item');
                            new_elm.setAttribute('data-city', JSON.stringify(item));
                            new_elm.innerHTML = `${item.city}, ${item.region}, ${item.sub_region}`;

                            new_elm.addEventListener('click', this.clickListCity);
                            this.listCities.appendChild(new_elm);
                        }
                    })

                    
                    if (data.length > 5) {
                        this.listCitiesContainer.classList.add('scroll');
                    } else {
                        this.listCitiesContainer.classList.remove('scroll');
                    }

                    this.searchLabelCity.classList.remove('proccessing');

                } else {
                    this.searchLabelCity.classList.remove('proccessing');
                }
                
            })
            .catch(error => {
                this.searchLabelCity.classList.remove('proccessing');
                notice(error, 'error');
            })
    }


    showCitiesList() {
        this.listCitiesContainer.classList.add('active');
    }


    hideCitiesList() {
        this.listCitiesContainer.classList.remove('active', 'scroll');
        this.listCities.innerHTML = '';
    }


    clickListCity = (e) => {
        e.preventDefault();
        const city_data = JSON.parse(e.target.getAttribute('data-city'));

        const location = {
            '_resultId':    city_data.code,
            'id':           city_data.city,
            'text':         city_data.city,
            'title':        `${city_data.country}, ${city_data.region}, ${city_data.city}`,
            'code':         city_data.code,
            'region':       city_data.region,
            'region_code':  city_data.region_code,
            'sub_region':   city_data.sub_region,
            'country':      city_data.country,
            'country_code': city_data.country_code,
            'longitude':    city_data.longitude,
            'latitude':     city_data.latitude,
            'selected':     true,
        };

        this.setCustomerLocation(location);
    }


    async setCustomerLocation(location) {
        if (this.loader) {
            this.loader.classList.add('active');
        }

        const formData = new FormData();

        let result = false;

        formData.append('customer_id', edostavka_checkout_params.customer_id);
        formData.append('beforeSend', '');

        Object.keys(location).forEach(key => {
            formData.append(`location[${key}]`, location[key]);
        })

        await fetch(`${backendData.siteUrl}?wc-ajax=edostavka_set_customer_location`, {
            method: 'POST',
            body: formData,
        })
            .then(resp => resp.json())
            .then(response => {
                const {
                    data,
                    success,
                } = response;

                if (success) {

                    result = true;

                    this.hideCitiesList();
                    
                    this.cityData = location;

                    this.inputCity.value = data.city;
                    this.inputCity.setAttribute('data-selected', this.inputCity.value);
                    this.inputState.value = data.region;
                    this.inputState.setAttribute('data-selected', this.inputState.value);

                    var inputEvent = new Event('input', {
                        bubbles: true,
                    });
                      
                    this.inputCity.dispatchEvent(inputEvent);
                    this.inputState.dispatchEvent(inputEvent);
                    
                    this.updateOrderReview(this.dataBuffer);
                }
            })
            .catch(error => {
                notice(error, 'error');
            })
        return result;
    }

}   
